import AOS from 'aos';

import { NavigationDropdowns } from './components/NavigationDropdowns';
import { MobileNavigation } from './components/MobileNavigation';
import { NewsletterForm } from './components/NewsletterForm';
import { MiniCalendar } from './components/MiniCalendar';
import { SmoothScroll } from './components/SmoothScroll';
import { ImageSlider } from './components/ImageSlider';
import { ContactForm } from './components/ContactForm';
import { HeroSlider } from './components/HeroSlider';
import { Accordion } from './components/Accordion';
import { OnScroll } from './components/OnScroll';
import { Iframe } from './components/Iframe';

const components = [
    NavigationDropdowns,
    MobileNavigation,
    NewsletterForm,
    MiniCalendar,
    SmoothScroll,
    ImageSlider,
    ContactForm,
    HeroSlider,
    Accordion,
    OnScroll,
    Iframe,
];

document.addEventListener('DOMContentLoaded', () => {
    components.forEach(Component => Component.create());
    AOS.init({
        offset: 100,
    });
});



// WEBPACK FOOTER //
// ./assets/js/main.js